import makeProjectName from "../../utils/makeProjectName";
import { apiSlice } from "../api/apiSlice";

export const projectsApi = apiSlice.injectEndpoints({
    tagTypes: ["Project"],
    endpoints: (builder) => ({
        getProjects: builder.query({
            query: (data) => {
                let queryString = "";
                queryString =
                    data?.length > 0
                        ? data?.map((tId) => `team.teamId=${tId}`).join("&")
                        : "";
                if (queryString)
                    return `/projects?${queryString}&_sort=timestamp&_order=desc`;
                else return " `/projects?team.teamId=null";
            },
            refetchOnMountOrArgChange: true,
            providesTags: ["Project"],
        }),
        getProject: builder.query({
            query: (name) => {
                return `/projects?title=${name}`;
            },
            refetchOnMountOrArgChange: true,
        }),
        addProject: builder.mutation({
            query: ({ data, team }) => ({
                url: "/projects",
                method: "POST",
                body: data,
            }),
            async onQueryStarted(arg, { queryFulfilled, dispatch }) {
                const project = await queryFulfilled;
                if (project?.data?.id) {
                    dispatch(
                        apiSlice.util.updateQueryData(
                            "getProjects",
                            arg.team,
                            (draft) => {
                                draft.push(project.data);
                            }
                        )
                    );
                }
            },
            invalidatesTags: ["Project"],
        }),
        editProject: builder.mutation({
            query: ({ id, data }) => ({
                url: `/projects/${id}`,
                method: "PATCH",
                body: data,
            }),
            invalidatesTags: ["Project"],
            // async onQueryStarted(arg, { queryFulfilled, dispatch }) {
            //     // optimistic cache update start
            //     const result = dispatch(
            //         apiSlice.util.updateQueryData(
            //             "getProjects",
            //             arg.team,
            //             (draft) => {
            //                 const projectItem = draft.find(
            //                     (p) => p.id == arg.id
            //                 );
            //                 projectItem.stateId = arg.data.stateId;
            //                 console.log(JSON.stringify(projectItem));
            //             }
            //         )
            //     );
            //     // optimistic cache update end

            //     try {
            //         const project = await queryFulfilled;
            //     } catch (err) {
            //         result.undo();
            //     }
            // },
        }),
        deleteProject: builder.mutation({
            query: (id) => ({
                url: `/projects/${id}`,
                method: "DELETE",
            }),
            invalidatesTags: ["Teams"],
        }),
    }),
});

export const {
    useGetProjectsQuery,
    useGetProjectQuery,
    useAddProjectMutation,
    useEditProjectMutation,
    useDeleteProjectMutation,
} = projectsApi;
